import { useMemo } from 'react';
import { rage } from '~/rage';
import { WalletType } from '~/shared';
import { StageTypes, useLayoutSelector } from '../redux';
import { useBuy } from './useBuy';

const useShopPreview = () => {
	const activeStage = useLayoutSelector(
		(state) => state.tuningShop.activeStage,
	);
	const activeList = useLayoutSelector((state) => state.tuningShop.activeList);
	const activeListIndex = useLayoutSelector(
		(state) => state.tuningShop.activeListIndex,
	);
	const tabIndex = useLayoutSelector((state) => state.tuningShop.tabIndex);
	const { handleBuy } = useBuy();

	const visible = useMemo(() => {
		return (
			activeStage === StageTypes.List &&
			activeListIndex !== null &&
			tabIndex === 0 &&
			activeList.length > 0
		);
	}, [activeStage, activeListIndex, tabIndex, activeList.length]);

	const item = useMemo(() => {
		return activeList[activeListIndex || 0];
	}, [activeList, activeListIndex]);

	const oldPrice = useMemo(() => {
		if (!item) return;
		if (!item.discount) return undefined;
		return item.price;
	}, [item?.discount, item?.price]);

	const actualPrice = useMemo(() => {
		if (!item) return 0;
		return rage.techTuning.getItemBuyPrice(item.id);
	}, [item]);

	return {
		visible,
		name: item?.name,
		price: actualPrice,
		handlePayByCash: () => handleBuy(WalletType.Cash),
		handlePayByCard: () => handleBuy(WalletType.Bank),
		handlePayByDonate: () => handleBuy(WalletType.Donate),
		// walletType:
		// 	item?.currency === Currency.Ruble ? WalletType.Cash : WalletType.Donate,
		walletType: WalletType.Cash,
		discount: item?.discount ? item?.discount * 100 : 0,
		oldPrice,
		bottomTitle:
			'Весь тюнинг будет добавлен в тюнинг инвентарь в основное меню',
	};
};

export { useShopPreview };
